import service from '@/utils/request'

/** 获取文章列表 */
export function getArticlePages(params) {
  return service.get(`/backend/article/list`, { params })
}
/** 获取文章详情 */
export function getArticleDetail(articleId) {
  return service.get(`/backend/article/detail?articleId=${articleId}`)
}
/** 提交保存文章内容 */
export function submitArticleDetail(data) {
  return service.post(`/backend/article/detail`, data)
}
/** 更新文章状态 */
export function updateArticleDetail(data) {
  return service.put(`/backend/article/detail`, data)
}
/** 删除文章 */
export function deleteArticleDetail(articleId) {
  return service.delete(`/backend/article/detail/${articleId}`)
}

/** 获取轮播图列表 */
export function getBannerPages(params) {
  return service.get(`/backend/banner/list`, { params })
}
/** 提交保存轮播图内容 */
export function submitBanner(data) {
  return service.post(`/backend/banner/detail`, data)
}
/** 更新轮播图状态 */
export function updateBanner(data) {
  return service.put(`/backend/banner/detail`, data)
}
/** 删除轮播图 */
export function deleteBanner(bannerId) {
  return service.delete(`/backend/banner/detail/${bannerId}`)
}

/** 获取退款原因列表 */
export function getRefundReasonList(params) {
  return service.get(`/backend/system/refundreason/list`, { params })
}
/** 提交保存退款原因 */
export function submitRefundReason(data) {
  return service.post(`/backend/system/refundreason/detail`, data)
}
/** 更新退款原因状态 */
export function updateRefundReason(data) {
  return service.put(`/backend/system/refundreason/detail`, data)
}
/** 删除退款原因 */
export function deleteRefundReason(reasonId) {
  return service.delete(`/backend/system/refundreason/detail/${reasonId}`)
}
